import Vue from 'vue'
import InputFacade from 'vue-input-facade'

Vue.use(InputFacade)
